"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoSource = exports.SourceType = void 0;
var SourceType;
(function (SourceType) {
    SourceType["Youtube"] = "YOUTUBE";
    SourceType["Facebook"] = "FACEBOOK";
    SourceType["Vimeo"] = "VIMEO";
    SourceType["HLS"] = "HLS";
    SourceType["MP4"] = "MP4";
})(SourceType || (exports.SourceType = SourceType = {}));
var VideoSource;
(function (VideoSource) {
    VideoSource["WixVideo"] = "WixVideo";
    VideoSource["MediaManager"] = "MediaManager";
})(VideoSource || (exports.VideoSource = VideoSource = {}));
//# sourceMappingURL=types.js.map